export default "__VITE_ASSET__d19dd68b__"